/** Shown wherever the viewer has view-only permission on the current record - see PageHeader's readOnly prop. */
export function ReadOnlyBanner() {
  return (
    <div className="readonly-banner" role="status">
      <strong>Read-only</strong> — you have view access to this record only.
    </div>
  );
}
